// extracted by mini-css-extract-plugin
export default {"message-list":"b3z05","message-list_empty":"QD3wA","message-list__button":"ABFcr","message-list__loader":"qjqCW","message-list__actions":"oS2Qj"};